import { QUERY_POLICIES } from '../../constants/actions/policies';

export function queryPolicies(payload) {
    return {
        type: QUERY_POLICIES,
        payload,
    };
}
